import { useParams, useLocation, useHistory, useRouteMatch } from 'react-router-dom';
import { useMemo } from 'react';

export function useRouter() {
  const params = useParams();
  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch();

  return useMemo(() => {
    return {
      push: history.push,
      replace: history.replace,
      pathname: location.pathname,
      query: new URLSearchParams(location.search),
      match,
      location,
      history,
      params,
    };
  }, [params, match, location, history]);
}
